import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { VendorModule } from '../../../vendor.module';
import { SharedModule } from '../../shared';
import {
  DeclarationNodeEditorComponent,
  DossierSummaryComponent,
  ProductDeclarationComponent,
  ProductDeclarationTreeComponent,
  ProductDetailsComponent,
  ProductFormComponent,
  SubstanceFormComponent
} from './product-details';
import { ProductsPageComponent } from './products-page.component';
import { EditProductDialogComponent, ProductsTableComponent, ProductsTableSearchComponent, ProductsTableTabComponent } from './products-table-tab';
import { DossierUploadTableComponent, UploadProductDialogComponent } from './upload-product-dialog';
import { ArticleCategoryListPipe, DeclarationNodeEditorHeaderTextPipe, ProductTypeLabelPipe, RequestedTypeTranslationKeyPipe } from './pipes';
import { ReactiveFormsModule } from '@angular/forms';

const components = [
  DeclarationNodeEditorComponent,
  DossierSummaryComponent,
  DossierUploadTableComponent,
  EditProductDialogComponent,
  ProductDeclarationTreeComponent,
  ProductDeclarationComponent,
  ProductDetailsComponent,
  ProductFormComponent,
  ProductsPageComponent,
  ProductsTableComponent,
  ProductsTableSearchComponent,
  ProductsTableTabComponent,
  SubstanceFormComponent,
  UploadProductDialogComponent
];

const pipes = [ArticleCategoryListPipe, DeclarationNodeEditorHeaderTextPipe, ProductTypeLabelPipe, RequestedTypeTranslationKeyPipe];

const modules = [RouterModule, VendorModule, SharedModule, TranslateModule, ReactiveFormsModule];

@NgModule({
  declarations: [...components, ...pipes],
  imports: [...modules]
})
export class ProductsModule {}
